// config.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDXU3dd0Hvc29NHu2G6zpgvJa2oKejtMUA",
  authDomain: "myclnq-fvhome.firebaseapp.com",
  projectId: "myclnq-fvhome",
  storageBucket: "myclnq-fvhome.firebasestorage.app",
  messagingSenderId: "757921142206",
  appId: "1:757921142206:web:46dcaef6230cb0499ad5ef",
  measurementId: "G-V1QWY8W32X"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
